import { render, staticRenderFns } from "./AboutNewsdetail.vue?vue&type=template&id=6bf8ae6d&scoped=true&"
import script from "./AboutNewsdetail.vue?vue&type=script&lang=js&"
export * from "./AboutNewsdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8ae6d",
  null
  
)

export default component.exports